/* oxlint-disable sorare/enforce-monetary-reward-disclaimer -- Non-reward currency (wallet/market/JONUM limits/etc.) — disclaimer does not apply. */
import { useCallback } from 'react';

import { useFormatFloorPricesFilters } from '#src/hooks/filters/useFormatFloorPricesFilters.ts';

type ReturnedProps = {
  sliderToPrice: (value: number) => string;
  priceToSlider: (value: number) => number;
};

const CENTS_PER_MAJOR_UNIT = 100;

// The index stores `market_values` in major EUR units, unlike `floor_prices` which stores cents.
export const useFormatMarketValuesFilters = (): ReturnedProps => {
  const { sliderToPrice: centsToPrice, priceToSlider: priceToCents } =
    useFormatFloorPricesFilters();

  return {
    sliderToPrice: useCallback(
      (value: number) => centsToPrice(value * CENTS_PER_MAJOR_UNIT),
      [centsToPrice]
    ),
    priceToSlider: useCallback(
      (value: number) => priceToCents(value) / CENTS_PER_MAJOR_UNIT,
      [priceToCents]
    ),
  };
};
